import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.paymentMethodSettings.title',
    defaultMessage: 'Payment methods',
    description: 'title of the payment methods settings on the configuration page',
  },
  subtitle: {
    id: 'pages.settings.general.paymentMethodSettings.subtitle',
    defaultMessage: 'Disable or rename methods',
    description: 'subtitle of the shipping method settings on the configuration page',
  },
  count: {
    id: 'pages.settings.general.paymentMethodSettings.count',
    defaultMessage: '{count} methods edited',
    description: 'count of the shipping method settings on the configuration page',
  },
  feedback: {
    paymentMethodsSettingsUpdated: {
      id: 'pages.settings.general.paymentMethodSettings.feedback.paymentMethodsSettingsUpdated',
      defaultMessage: 'Payment methods saved',
      description: 'feedback on the successful update of price group settings',
    },
    paymentMethodsSettingsNotUpdated: {
      id: 'pages.settings.general.paymentMethodSettings.feedback.paymentMethodsSettingsNotUpdated',
      defaultMessage: 'Payment methods could not be saved',
      description: 'feedback on the failed update of price group settings',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.paymentMethodSettings.editDrawer.title',
      defaultMessage: 'Edit payment methods',
      description: 'title of the edit payment methods drawer',
    },
    methodsArrayField: {
      label: {
        id: 'properties.methods',
        defaultMessage: 'Methods',
        description: 'label of the methods array field',
      },
    },
    paymentMethodField: {
      label: {
        id: 'properties.paymentMethod',
        defaultMessage: 'Payment method',
        description: 'title of the edit price group drawer',
      },
    },
    labelField: {
      label: {
        id: 'properties.label',
        defaultMessage: 'Label',
        description: 'label of the label field',
      },
    },
    priorityField: {
      label: {
        id: 'properties.priorityNumber',
        defaultMessage: 'Priority',
        description: 'label of the label priority',
      },
    },
    isEnabledField: {
      label: {
        id: 'properties.isEnabled',
        defaultMessage: 'Enabled',
        description: 'label of the is enabled field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
